import { Component,Input, OnInit } from '@angular/core';
import {DadosService} from '../../db/dados.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  items:any[];
  constructor(private dados:DadosService, private router:Router) { }

  ngOnInit() {
    this.dados.getPublicidade(0,d=>{
      this.items = d;
    });
  }

  publicidade(pagina){
    return this.items;
  }

  validar(item){
    if (item.linkText==null)
       item.linkText = 'mais';
  }

  goItem(item){
    console.log(item);
    this.dados.regAnalytics(item.anunciante,'publicidade','anunciante',1);
    this.router.navigate([item.link]);
  }
  goto(rota){
    this.dados.goto(rota);
  }
  database(){
    return this.dados;
  }

 @Input()
 get config(){
    return this.dados.config;
  }

 estouComSorte(){
   this.dados.regAnalytics(0,'acessos','estouComSorte',1);
  this.goto('/estouComSorte/promocao');
 } 

 meusPedidos(){
  this.dados.regAnalytics(0,'acessos','meusPedidos',1);
  this.goto('/meusPedidos');
 }

}
